module.exports = __webpack_public_path__ + "img/hands.52ecc06e.png";